import { RootState } from "index";

export const selectYears = (state: RootState) => state.years